<!-- Доменная конфигурация общего прогресса поручения экспедитору. -->
<template>
  <EdoDocumentFlowDetails
    :flow="flow"
    :title-details="titleDetails"
    :read-only="readOnly"
    :inspectable="inspectable"
    :variant="variant"
    title="Информация по этапам поручения экспедитору"
    :guides="stepGuides"
    :fallback-guide="fallbackGuide"
    @title-action="$emit('title-action', $event)"
  />
</template>

<script>
import {
  FORWARDING_FALLBACK_GUIDE,
  FORWARDING_STEP_GUIDES,
} from "@/components/Edo/forwardingFlowConfig";
import EdoDocumentFlowDetails from "@/components/Edo/shared/EdoDocumentFlowDetails.vue";

export default {
  name: "EdoForwarderOrderFlowDetails",

  emits: ["title-action"],

  components: {
    EdoDocumentFlowDetails,
  },

  props: {
    flow: {
      type: Object,
      default: null,
    },
    titleDetails: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    inspectable: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "card",
      validator: (value) => ["card", "embedded", "flat"].includes(value),
    },
  },

  computed: {
    stepGuides() {
      return FORWARDING_STEP_GUIDES;
    },

    fallbackGuide() {
      return FORWARDING_FALLBACK_GUIDE;
    },
  },
};
</script>
